/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type editBotProfile_bot$ref: FragmentReference;
declare export opaque type editBotProfile_bot$fragmentType: editBotProfile_bot$ref;
export type editBotProfile_bot = {|
  +id: string,
  +rowId: any,
  +name: string,
  +description: ?string,
  +avatar: ?string,
  +organization: ?{|
    +id: string,
    +rowId: any,
    +name: string,
    +canUpdate: ?boolean,
  |},
  +$refType: editBotProfile_bot$ref,
|};
export type editBotProfile_bot$data = editBotProfile_bot;
export type editBotProfile_bot$key = {
  +$data?: editBotProfile_bot$data,
  +$fragmentRefs: editBotProfile_bot$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "editBotProfile_bot",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "avatar",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canUpdate",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Bot"
};
})();
// prettier-ignore
(node/*: any*/).hash = '5d09b7e72fbaedbe6a3359f08ea8881e';

module.exports = node;
